var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpgradeNullBlade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 560 560",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #78fff2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.1,233.83l330.54,30.91,26.46,10.3H66.96l58.13-41.2M123.72,228.68l-72.46,51.35h457.48l-51.94-20.21-333.08-31.14h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M482.1,284.96l-26.46,10.3-330.54,30.91-58.13-41.2h415.14M508.74,279.96H51.26l72.46,51.35,333.08-31.14,51.94-20.21h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradeNullBlade);
export default __webpack_public_path__ + "static/media/upgrade-null-blade.445e6aa499e87e6bd06a1ad364ad3b7b.svg";
export { ForwardRef as ReactComponent };